import inventoryFullcont  from "./inventory-fullcont.html";

const dialog           = require ('../../../../../components/dialog/dialog')
const fullcontEntity   = require ('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler  = require ('../../../../../components/fullcont/fullcont-handler')
const inventoryDt      = require('./inventory-dt')
const {formCopy}       = require('./inventory-fullcont-form') 
const {form}           = require('./inventory-fullcont-form')
const inventoryHandler = require('./inventory-fullcont-handler')
const {inventoryMT}    = require('./inventory-fullcont-multitable')

/****************ELEMENTS*****************/
var htmlFc          = {}
var HTMLwasSelected = false

function HTMLselect(detail){ 

    fullcontHandler.HTMLselect(

            'inventory', //database table name****
            'inventory', //dest entity on js
            'inventory-fullcont', 
             inventoryFullcont, form, formCopy, inventoryMT, 
             editDialog, deleteDialog, dtCall, htmlFc)

            HTMLwasSelected   = true 
             
      htmlFc.addOne = 'server/php/sql/insertPurchaseVsLost.php'

      // htmlFc.hasFiles = true
      // fullcontHandler.rightsControl(htmlFc)
}/**/


export function start(detail){ 
  
      if(!HTMLwasSelected) { HTMLselect(detail) }
       
      obj[detail.act].start(detail)
}/**/


const obj = {

      addOne:             { start: (detail)=>{  addOne(detail, htmlFc)                                        }},
      cancelEdit:         { start: (detail)=>{  fullcontEntity.cancelEdit(detail, htmlFc)                     }},
      discard:            { start: (detail)=>{  fullcontHandler.discard(detail, htmlFc)                       }},
      hide:               { start: (detail)=>{  fullcontEntity.hide(detail, htmlFc)                           }},
      prepareAdd:         { start: (detail)=>{  prepareAdd(detail)                                            }},
      saveFromDialog:     { start: (detail)=>{  saveFromDialog(detail, htmlFc)                                }},
      processQtyItemLost: { start: (detail)=>{  inventoryHandler.processQtyItemLost(detail, htmlFc)           }},

}/**/

function prepareAdd(detail) {
      fullcontEntity.prepareAdd(detail, htmlFc, (response) => { getItemInformation(response, detail) })
}

function getItemInformation(htmlFc, detail) {
      inventoryHandler.addDataDetail(detail,htmlFc);

      inventoryHandler.getItemInformation(detail,htmlFc)
}

//function to send
function editDialog(){
        dialog.start({ act:"show", id:"saveChanges", entity:'inventory' } )
}

function deleteDialog(detail){
        dialog.start({ act:"show",  dest:'inventory', id:"deleteElem", entity:'inventory', dbid: detail.dbid } )
}

function dtCall(act, result){ 
      //inventoryDt.start({act:act, row: result})
}

function addOne(detail, htmlFc){
      if (inventoryHandler.validated(detail, htmlFc)) {
            fullcontEntity.addOne(detail, htmlFc,afterAddOne) 
      } 
}

function afterAddOne(data, result) {
      inventoryDt.start({"dest":"inventory", "elem":"dt", "act":"select", "entity":"inventory"})
      inventoryHandler.getItemInformation({},htmlFc)

      // para que despues de agregar un lost, vuelva a estar en modo add
      htmlFc.fullcontHTML.classList.remove('mode-view')
      htmlFc.fullcontHTML.classList.remove('mode-edit')
      htmlFc.fullcontHTML.classList.add('mode-add')

}

function saveFromDialog(detail, htmlFc) {
      if (inventoryHandler.validated(detail, htmlFc)) {
            fullcontEntity.saveFromDialog(detail, htmlFc,afterAddOne)
      } 
}

